<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.dateRangeTitle }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateFrom"
                            :label="labels.tranDateFrom"
                            :data-vv-as="labels.tranDateFrom"
                            data-vv-name="tranDateFrom"
                            :error-messages="errors.collect('tranDateFrom')"
                            v-validate="'required'"
                            ref="fromDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateTo"
                            :label="labels.tranDateTo"
                            :data-vv-as="labels.tranDateTo"
                            data-vv-name="tranDateTo"
                            :error-messages="errors.collect('tranDateTo')"
                            v-validate="'required|from_to_date:fromDate'"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.selectionCriteria }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Business Class  -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="forms.busCls"
                            :label="labels.busCls"
                            :error-messages="errors.collect('busCls')"
                            :data-vv-as="labels.busCls"
                            data-vv-name="busCls"
                            append-icon="mdi-magnify"
                            @click:append="multiBusClsList = true"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-btn color="primary" dark class=" mr-2" :loading="processing" @click.prevent="doSubmit">
            <v-icon dark left>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="forms.format">
            <v-btn text>
              <span>{{ labels.format }}</span>
              <v-icon :color="'green'">mdi-file-excel</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="multiBusClsList" width="900px" persistent>
      <multi-bus-cls-help-list :busCls="forms.busCls" :busClsAppId="'audit'" @close="multiBusClsList = false" @doAssign="doAssignBusCls($event)"></multi-bus-cls-help-list>
    </v-dialog>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList'

export default {
  data() {
    return {
      labels: {
        dateRangeTitle: 'Date Range',
        selectionCriteria: 'Selection Criteria',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        busCls: 'Business Class',
        export: 'Export To',
        format: 'EXCEL'
      },
      forms: {
        tranDateFrom: null,
        tranDateTo: null,
        busCls: 'All'
      },
      processing: false,
      showErrorDialog: false,
      menu: {},
      multiBusClsList: false,
      panel1: [0],
      panel2: [0]
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    }
  },
  methods: {
    async doInit() {},
    doAssignBusCls(Obj) {
      this.forms.busCls = []
      this.forms.busCls = Obj.finalSelectedItems.toString()
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.exportWICPolMOMAudit
      if (apiUrl) {
        try {
          this.processing = true
          await this.$http.post(apiUrl, this.forms)
          this.$toast.success('Submitted Successfully.')
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportWICPolMOMAudit]')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin],
  components: {
    MultiBusClsHelpList
  }
}
</script>
